import React, { FC } from 'react';
import { AnswerCheckmark, AnswerLabel, InputWrapper } from './Answer.style';

type AnswerProps = {
  type?: 'checkbox' | 'radio';
  id: string;
  label: string;
  name: string;
  onClick?: (id: string) => void;
  defaultChecked?: boolean;
  isAnimated?: boolean;
};

const Answer: FC<AnswerProps> = ({
  id,
  name,
  label,
  type = 'radio',
  onClick,
  defaultChecked = false,
  isAnimated = false,
}) => {
  return (
    <InputWrapper className={`${isAnimated ? 'animated' : ''}`}>
      <input type={type} name={name} defaultChecked={defaultChecked} onClick={() => onClick?.(id)} />
      <AnswerLabel className={`${defaultChecked ? 'checked' : ''}`}>{label}</AnswerLabel>
      <AnswerCheckmark className={`${defaultChecked ? 'checked' : ''}`} />
    </InputWrapper>
  );
};

export default React.memo(Answer);
